<p>e-gift-email-setup works!</p>
